module.exports = __webpack_public_path__ + "img/Scatter.a3766ef9.png";